import { useTranslation } from "react-i18next";

export const Kicker = ({ children }) => (
  <p className="text-primary text-xs font-bold uppercase tracking-[0.25em]">{children}</p>
);

export const PageHero = ({ kicker, title, subtitle, testId }) => (
  <section className="border-b bg-secondary/50" data-testid={testId}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <Kicker>{kicker}</Kicker>
      <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);

export const useLocalizedDate = () => {
  const { i18n } = useTranslation();
  return (iso) =>
    new Date(iso).toLocaleDateString(i18n.resolvedLanguage, { year: "numeric", month: "long", day: "numeric" });
};
